module.exports = __webpack_public_path__ + "static/media/make-search.9138b84c.svg";